import {
  Box,
  Flex,
  Grid,
  Radio,
  RadioGroup,
  Stack,
  Text
} from '@chakra-ui/react'
import { FC, useState } from 'react'
import ReactApexChart from 'react-apexcharts'

import LayoutEmpty from '@component/Layout/Empty'

import { IGraphicResponse } from '@base/@types/providers/Kpi/RuptureProvider'

import {
  getStorageSeries,
  storageOptions
} from './ParseInfos/parseRuptureChartInfos'
interface IKpiStorageGraphicProps {
  data: IGraphicResponse
}

const KpiRuptureGraphic: FC<IKpiStorageGraphicProps> = ({ data }) => {
  const [dataMap, setDataMap] = useState(data.ruptura)
  const [value, setValue] = useState('0')
  return (
    <Box borderTop="1px solid #e3e3e3">
      <Flex
        flexDir="column"
        alignItems="center"
        background="gray.100"
        paddingTop={2}
        paddingBottom={0}
      >
        <RadioGroup value={value}>
          <Stack spacing={8} direction="row">
            <Radio
              size="sm"
              borderColor="blackAlpha.300"
              value="0"
              onClick={_e => {
                setDataMap(data.ruptura)
                setValue('0')
              }}
            >
              <Text
                onClick={_e => {
                  setDataMap(data.ruptura)
                  setValue('0')
                }}
              >
                {' '}
                0 Dias{' '}
              </Text>
            </Radio>

            <Radio
              size="sm"
              borderColor="blackAlpha.300"
              value="10"
              onClick={_e => {
                setDataMap(data.rupturaDezDias)
                setValue('10')
              }}
            >
              <Text
                onClick={_e => {
                  setDataMap(data.rupturaDezDias)
                  setValue('10')
                }}
              >
                {' '}
                10 Dias{' '}
              </Text>
            </Radio>
          </Stack>
        </RadioGroup>
      </Flex>

      <Grid background="gray.100" paddingTop={4}>
        {data.ruptura.length === 0 ? (
          <Box height={250}>
            <LayoutEmpty
              type="chartEmpty"
              title="Nada encontrado!"
              message="Filtre sua busca ao lado para obter informações"
            />
          </Box>
        ) : (
          <Box paddingLeft={2}>
            <ReactApexChart
              options={storageOptions(dataMap)}
              series={getStorageSeries(dataMap)}
              width="100%"
              height="222px"
            />
          </Box>
        )}
      </Grid>
    </Box>
  )
}

export default KpiRuptureGraphic
